<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">角色</p>
        <el-select v-model="roleName" placeholder="请选择账号角色" clearable>
          <el-option
              v-for="item in roleValueList"
              :key="item.roleName"
              :label="item.roleName"
              :value="item.roleName">
          </el-option>
        </el-select>
      </div>
      <el-button class="searchBtn btn1" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn btn2" type="warning" @click="addAccount">创建角色</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table
            v-loading="loading"
            :data="tableData"
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false"
            :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <template v-for="(item, index) in tableColumns">
            <el-table-column
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width">
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">编辑</el-button>
              <el-button class="tableBtn" @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
          class="paginationBody">
      </el-pagination>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog
          :title="eventControl"
          :visible.sync="dialogFormVisible"
          :before-close="closeAdd"
          center
      >
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <el-form-item label="角色名称" label-width=".90rem" prop="roleName" class="formItem">
            <el-input v-model="addForm.roleName" auto-complete="off"></el-input>
          </el-form-item>
          <p style="margin-left: .2rem">选择页面权限</p>
          <div style="margin-left: 1rem">
            <el-tree
                :data="pageList"
                :show-checkbox="true"
                node-key="id"
                ref="pageTree"
                :check-strictly="false"
                :default-expand-all="true"
                :default-checked-keys="assignPageList"
                :props="{
              children: 'children',
              label: 'label'
             }">
            </el-tree>
          </div>
          <el-form-item label="备注" label-width=".90rem" style="margin-top: .2rem">
            <el-input type="textarea" style="width: 80%;vertical-align:top"
                      :autosize="{ minRows: 2, maxRows: 3}" v-model="addForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeAdd">取 消</el-button>
          <el-button type="primary" @click="addEventForm()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { listRoleInfo } from '@/api/searchList'
import { addRoleInfo, queryRoleInfo, updateRoleInfo, deleteRoleInfo } from '@/api/basicInfo'
import menuList from '@/router/menu'
import { Message } from 'element-ui'

export default {
  name: 'role',
  data () {
    return {
      loading: false,
      roleName: '',
      roleValueList: [],
      companyValueList: [],
      stateValue: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      pageList: [],
      assignPageList: [],
      edit: '',
      addForm: {
        roleName: '',
        remark: ''
      },
      rules: {
        roleName: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      tableData: [],
      tableColumns: [
        {
          prop: 'roleName',
          label: '角色名称'
        },
        {
          prop: 'remark',
          label: '角色描述'
        }
      ]
    }
  },
  mounted () {
    this.getData()
    this.getPageList()
    this.getRoleValueList()
  },
  methods: {
    // 角色下拉框
    async getRoleValueList () {
      let res = await listRoleInfo({})
      if (res.code === 0) {
        this.roleValueList = res.result
      }
    },
    getData () {
      this.currentPage = 1
      this.queryList()
    },
    async queryList () {
      let res = await queryRoleInfo({
        roleName: this.roleName,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    addStablePage (row) {
      let pagePermissionList = []
      if (row.pageUrls) {
        pagePermissionList = row.pageUrls.split(',')
        let tem = new Set(pagePermissionList)
        // 如果没有选首页，则自动加上首页
        if (!tem.has('/home/index')) {
          pagePermissionList.push('/home/index')
        }
      }
      this.$nextTick(() => {
        this.$refs.pageTree.setCheckedKeys(pagePermissionList)
      })
    },
    addAccount () {
      this.edit = false
      this.dialogFormVisible = true
      this.eventControl = '创建角色'
      // 新增角色时加上首页
      let pagePermissionList = []
      pagePermissionList.push('/overview/index')
      this.$nextTick(() => {
        this.$refs.pageTree.setCheckedKeys(pagePermissionList)
      })
    },
    async viewOrHandle (row) {
      this.edit = true
      this.eventControl = '编辑角色'
      this.addForm.roleName = row.roleName
      this.addForm.remark = row.remark
      this.id = row.id
      // 自动加上首页
      let pagePermissionList = []
      if (row.pageUrls) {
        pagePermissionList = row.pageUrls.split(',')
        let tem = new Set(pagePermissionList)
        // 如果没有选首页，则自动加上首页
        if (!tem.has('/overview/index')) {
          pagePermissionList.push('/overview/index')
        }
      }
      console.log(pagePermissionList, 'pagePermissionList');
      let parentNode = [
        '/comprehensive', 
        '/comprehensive/certificates', 
        '/comprehensive/checkWork', 
        '/comprehensive/reimbursement', 
        '/comprehensive/carManagement', 
        '/comprehensive/overTime', 
        '/comprehensive/leaveTime', 
        '/basicInfo', 
        '/contract', 
        '/partyBuilding',
        '/community',
        '/report',
      ]
      pagePermissionList = pagePermissionList.filter(v => !parentNode.includes(v))
      this.$nextTick(() => {
        this.$refs.pageTree.setCheckedKeys(pagePermissionList)
      })
      this.dialogFormVisible = true
    },
    closeAdd () {
      this.dialogFormVisible = false
      this.$refs['addForm'].resetFields()
      this.addForm = {
        roleName: '',
        remark: ''
      }
    },
    addEventForm () {
      // 如果选择'首页'和‘合同管理’，则相对应的加上'审批记录'和'打印合同'的路由
      // 如果选择模板管理，则加上新增编辑模板，如果选择合同管理，则加上新增编辑合同
      // 如果选择租金月度汇总，则加上“打印租金月度汇总”；如果选择租金单列统计，则加上“打印租金单列统计”；如果选择待租房屋明细，则加上“打印待租房屋明细”；

      let data1 = this.$refs.pageTree.getCheckedKeys()
          let halfChecked = this.$refs.pageTree.getHalfCheckedKeys()
          let data = [...data1, ...halfChecked]
      let pageTem = new Set(data)
      if (pageTem.has('/overview/index')) {
        data.push('/overview/approvalOpinion')
      }
      if (pageTem.has('/contract/management')) {
        data.push('/contract/previewContract')
        data.push('/contract/addContract')
      }
      if (pageTem.has('/contract/template')) {
        data.push('/contract/addTemplate')
      }
      if (pageTem.has('/report/houseRent')) {
        data.push('/report/printHouseRent')
      }
      if (pageTem.has('/report/buildingRent')) {
        data.push('/report/printBuildingRent')
      }
      if (pageTem.has('/report/forRent')) {
        data.push('/report/printForRent')
      }
      if (pageTem.has('/contract/taxManagement')) {
        data.push('/contract/addTax')
      }
      if (pageTem.has('/partyBuilding/partyNewInfo')) {
        data.push('/partyBuilding/addParty')
      }
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          if (this.edit) {
            let res = await updateRoleInfo({
              roleName: this.addForm.roleName,
              remark: this.addForm.remark,
              pageUrls: data.join(','),
              id: this.id
            })
            if (res.code === 0) {
              Message.success('新增成功！')
              this.$refs['addForm'].resetFields()
              this.dialogFormVisible = false
              this.addForm = {
                roleName: '',
                remark: ''
              }
              await this.getData()
              await this.getRoleValueList()
            } else {
              Message.error(res.message)
            }
          } else {
            let res = await addRoleInfo({
              roleName: this.addForm.roleName,
              remark: this.addForm.remark,
              pageUrls: data.join(',')
            })
            if (res.code === 0) {
              Message.success('新增成功！')
              this.$refs['addForm'].resetFields()
              this.dialogFormVisible = false
              this.addForm = {
                roleName: '',
                remark: ''
              }
              await this.getData()
              await this.getRoleValueList()
            } else {
              Message.error(res.message)
            }
          }
        }
      })
    },
    // 删除用户
    deleteFun (row) {
      this.$confirm('此操作将删除改账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await deleteRoleInfo(params)
        if (res.code === 0) {
          Message.success('删除成功！')
          await this.getRoleValueList()
          await this.getData()
        }
      })
    },
    // 获取页面权限
    getPageList () {
      let data = []
      menuList.forEach((item, index) => {
        data[index] = {}
        data[index].id = item.path
        data[index].label = item.meta.title
        // if (data[index].label === '首页') {
        //   data[index].disabled = true
        // }
        if (item.children && item.children.length) {
          // 特殊判断，如果是双层路由单标题的情况，使用redirect
          if (!item.children[0].meta.title) {
            data[index].id = item.redirect
          }
          let cList = item.children
          cList.forEach((item2, i) => {
            if (item2.meta.title) {
              if (!data[index].children) {
                data[index].children = []
              }
              // '审批记录'和'打印合同'、‘新增编辑模板’、‘新增编辑合同’,'打印租金月度汇总','打印租金单列统计','打印待租房屋明细'这几个标题不显示
              if (item2.meta.title !== '审批记录' && item2.meta.title !== '打印合同' && item2.meta.title !== '动态发布' && item2.meta.title !== '凭证录入' &&
                item2.meta.title !== '新增/编辑模板' && item2.meta.title !== '新增/编辑合同' &&
                item2.meta.title !== '打印租金月度汇总' && item2.meta.title !== '打印租金单列统计' && item2.meta.title !== '打印待租房屋明细') {
                data[index].children.push({
                  id: item.path + '/' + item2.path,
                  label: item2.meta.title
                })
              }
              // 三级标题
              if (item2.children && item2.children.length) {
                let cList2 = item2.children
                cList2.forEach((item3, i3) => {
                  if (item3.meta.title) {
                    if (!data[index].children[i].children) {
                      data[index].children[i].children = []
                    }
                    data[index].children[i].children.push({
                      id: item.path + '/' + item2.path + '/' + item3.path,
                      label: item3.meta.title
                    })
                  }
                })
              }
            }
          })
        }
      })
      // console.log(data)
      this.pageList = data
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
  }
  .searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;

    .stateDiv {
      margin-top: 0.14rem;
      float: left;
    }

    .searchText {
      margin-top: 0.05rem;
      margin-right: 0.13rem;
      font-size: 0.2rem;
      color: #111111;
      float: left;
    }

    .inputDiv {
      width: 2.2rem;
      float: left;
    }

    .searchBtn {
      /*width: 1.20rem;*/
      /*height: 0.36rem;*/
      /*border-radius: 0.06rem;*/
      /*font-size: 0.18rem;*/
      margin-top: 0.14rem;
      /*padding-top: 0.1rem;*/
    }
    .btn1{
      margin-left: .5rem;
    }
    .btn2{
      margin-left: .4rem;
    }
  }
  .table{
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;
    .searchList{
    }
    .paginationBody{
      margin-top: .1rem;
    }
  }
  .formItem{
    width: 3.2rem;
  }
  /deep/ .el-dialog{
    width: 23%!important;
  }
</style>
